import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Line } from './Line'
import Text from './Text'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: 8,
    flexGrow: 1,
  },
  verticalLine: {
    width: 4,
    height: '100%',
    borderRadius: '50%',
  },
  line: {
    marginBottom: 8,
  },
  text: {
    fontSize: 12,
    maxWidth: 490,
  },
  title: {
    color: colors.strongGray,
    fontSize: 12,
    fontFamily: 'Inter-Bold',
  },
})

const NoRiskMessage = ({ title, text }) => (
  <View>
    <View style={[styles.container, { marginTop: 20 }]}>
      <View
        style={[styles.verticalLine, { backgroundColor: colors.strongGreen }]}
      />
      <View style={{ marginLeft: 16 }}>
        <Text style={[{ color: colors.strongGray }, styles.text]}>
          <Text style={styles.title}>{title}</Text>
          {text}
        </Text>
      </View>
    </View>
    <Line style={styles.line} />
  </View>
)

NoRiskMessage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default NoRiskMessage
